import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=823655d2&scoped=true"
import script from "./ListTemplate.vue?vue&type=script&lang=ts"
export * from "./ListTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=823655d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823655d2",
  null
  
)

export default component.exports